const _ = require('lodash');
const { format } = require('./index');

function sortNumber(a, b) {
    return a - b;
}

const getDateRange = (dateRange, locale) => {
    if (dateRange.length === 1) return `${dateRange[0].year}/${dateRange[0].month}`;

    const list = {};
    dateRange.forEach((item) => {
        const { year, month } = item;

        if (_.isUndefined(list[year])) list[year] = [];
        list[year].push(month);
    });
    const yearList = Object.keys(list);
    const minYear = _.min(yearList);
    const maxYear = _.max(yearList);
    const minMonth = list[minYear].sort(sortNumber)[0];
    const maxMonth = list[maxYear].sort(sortNumber).reverse()[0];
    const minDate = format({ date: new Date(minYear, minMonth - 1), locale });
    const maxDate = format({ date: new Date(maxYear, maxMonth - 1), locale });
    return `${minDate} ~ ${maxDate}`;
};

export default getDateRange;
